import { render, staticRenderFns } from "./ChartsItem.vue?vue&type=template&id=2248b38b&"
import script from "./ChartsItem.vue?vue&type=script&lang=js&"
export * from "./ChartsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports